import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";

const PrenotazioneAddOffcanvas = ({
    show,
    handleClose,
    users_all,
    setIdUtente,
    id_utente,
    stato_prenotazione,
    token,
    insertcammino,
    setModalError,
    setModalSuccess,
    getAlloggi,
    setAlloggi,
    setAlloggiBackup,
    refreshPrenotazioni,
}) => {
    const [submitting, setSubmitting] = useState(false);
    const [isAgencyBooking, setIsAgencyBooking] = useState(false);
    const [nomeCliente, setNomeCliente] = useState("");
    const [cognomeCliente, setCognomeCliente] = useState("");
    const [emailCliente, setEmailCliente] = useState("");
    const [orderId, setOrderId] = useState("");

    const selectedUser = users_all.find(
        (u) => String(u.id) === String(id_utente)
    );
    const selectedIsAgency = selectedUser && selectedUser.isAgency == 1;

    React.useEffect(() => {
        if (!selectedIsAgency && isAgencyBooking) {
            setIsAgencyBooking(false);
        }
    }, [selectedIsAgency, isAgencyBooking]);

    const resetAgencyFields = () => {
        setIsAgencyBooking(false);
        setNomeCliente("");
        setCognomeCliente("");
        setEmailCliente("");
        setOrderId("");
    };

    const closeAndReset = () => {
        resetAgencyFields();
        handleClose();
    };

    const handleInsertPrenotazione = async () => {
        if (submitting) return;
        if (!id_utente || id_utente === 0 || id_utente === "seleziona un utente") {
            setModalError("Seleziona un utente prima di inserire la prenotazione");
            return;
        }
        if (isAgencyBooking && !selectedIsAgency) {
            setModalError("L'utente selezionato non è un'agenzia. Non è possibile creare una prenotazione agenzia per un cliente normale.");
            return;
        }
        if (isAgencyBooking) {
            if (!nomeCliente || nomeCliente.trim() === "") {
                setModalError("Inserire nome e cognome del cliente.");
                return;
            }
            if (!emailCliente || emailCliente.trim() === "") {
                setModalError("Inserire mail o telefono di contatto.");
                return;
            }
            if (!orderId || orderId.trim() === "") {
                setModalError("Inserire ID ordine.");
                return;
            }
        }
        setSubmitting(true);
        await setModalError(false);
        try {
            const agencyData = isAgencyBooking
                ? { nomeCliente, cognomeCliente, emailCliente, orderId }
                : undefined;
            let resultInsert = await insertcammino(
                token,
                id_utente,
                stato_prenotazione,
                0,
                agencyData
            );

            const ok = resultInsert && typeof resultInsert.status === "number" && resultInsert.status >= 200 && resultInsert.status < 300;
            if (ok) {
                let result_post_delete = await getAlloggi(token);
                setAlloggi(result_post_delete);
                setAlloggiBackup(result_post_delete);
                if (refreshPrenotazioni) await refreshPrenotazioni();
                resetAgencyFields();
                handleClose();
                if (setModalSuccess) setModalSuccess("Prenotazione inserita con successo");
            } else {
                setModalError("Errore durante l'inserimento della prenotazione");
            }
        } catch (e) {
            setModalError("Errore durante l'inserimento della prenotazione");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Offcanvas
            className="offcanvas-custom"
            placement="end"
            show={show}
            onHide={closeAndReset}
        >
            <Offcanvas.Header>
                <img
                    onClick={closeAndReset}
                    className="btn-close-img"
                    src="/closeBtn.svg"
                />
                <p
                    style={{
                        color: "#B1B1B1",
                        fontSize: "2em",
                        marginBottom: "0",
                        position: "absolute",
                        left: "60px",
                    }}
                >
                    Prenotazioni - Aggiungi
                </p>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div style={{ paddingLeft: "35px", paddingRight: "35px" }}>
                    <div>
                        <div>
                            <div>
                                <h1
                                    style={{
                                        fontSize: "1.3em",
                                        fontWeight: "700",
                                        marginBottom: "40px",
                                        marginTop: "30px",
                                    }}
                                >
                                    Aggiungi Prenotazione
                                </h1>
                            </div>

                            <div>
                                <div className="md-form mb-2">
                                    <i className="fas fa-user prefix grey-text"></i>

                                    <label>Utente</label>
                                    <select
                                        onChange={(e) => setIdUtente(e.target.value)}
                                        type="text"
                                        id="orangeForm-name"
                                        className="form-control validate"
                                    >
                                        <option value={"seleziona un utente"}>
                                            Seleziona un utente
                                        </option>
                                        {users_all.map((utente) => (
                                            <option key={utente.id} value={utente.id}>
                                                {utente.id} - {utente.nome} {utente.cognome}
                                                {utente.isAgency == 1 ? " (Agenzia)" : ""}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div style={{ marginTop: "20px" }}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                        opacity: selectedIsAgency ? 1 : 0.6,
                                        cursor: selectedIsAgency ? "pointer" : "not-allowed",
                                    }}
                                    onClick={() => {
                                        if (selectedIsAgency) setIsAgencyBooking(!isAgencyBooking);
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={isAgencyBooking}
                                        disabled={!selectedIsAgency}
                                        onChange={(e) => setIsAgencyBooking(e.target.checked)}
                                        onClick={(e) => e.stopPropagation()}
                                        style={{
                                            width: "20px",
                                            height: "20px",
                                            minWidth: "20px",
                                            margin: 0,
                                            accentColor: "#9B3601",
                                            cursor: selectedIsAgency ? "pointer" : "not-allowed",
                                        }}
                                    />
                                    <span style={{ fontWeight: 600, lineHeight: 1 }}>
                                        Crea come prenotazione agenzia
                                    </span>
                                </div>
                                <p style={{ color: "#888", fontSize: "0.85em", marginTop: "4px" }}>
                                    {selectedIsAgency
                                        ? "Se attivata, richiede i dati del cliente finale e il numero di prenotazione dell'agenzia."
                                        : "Disponibile solo selezionando un utente di tipo agenzia."}
                                </p>
                            </div>

                            {isAgencyBooking && (
                                <div
                                    style={{
                                        backgroundColor: "#E8F5E8",
                                        padding: "15px",
                                        borderRadius: "8px",
                                        border: "1px solid #4CAF50",
                                        marginTop: "10px",
                                    }}
                                >
                                    <p style={{ margin: "0 0 12px 0", color: "#2E7D32", fontWeight: "600" }}>
                                        Dati cliente agenzia
                                    </p>

                                    <div className="md-form mb-2">
                                        <label>Nome e Cognome *</label>
                                        <input
                                            type="text"
                                            value={nomeCliente}
                                            onChange={(e) => setNomeCliente(e.target.value)}
                                            className="form-control validate"
                                        />
                                    </div>

                                    <div className="md-form mb-2">
                                        <label>Altri passeggeri</label>
                                        <input
                                            type="text"
                                            value={cognomeCliente}
                                            onChange={(e) => setCognomeCliente(e.target.value)}
                                            className="form-control validate"
                                        />
                                    </div>

                                    <div className="md-form mb-2">
                                        <label>Mail / telefono di contatto *</label>
                                        <input
                                            type="text"
                                            value={emailCliente}
                                            onChange={(e) => setEmailCliente(e.target.value)}
                                            className="form-control validate"
                                        />
                                    </div>

                                    <div className="md-form mb-2">
                                        <label>Numero prenotazione (ID Ordine) *</label>
                                        <input
                                            type="text"
                                            value={orderId}
                                            onChange={(e) => setOrderId(e.target.value)}
                                            className="form-control validate"
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="modal-footer d-flex justify-content-center">
                                <button
                                    onClick={handleInsertPrenotazione}
                                    disabled={submitting}
                                    className="btn btn-deep-orange close btn-update"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    style={submitting ? { opacity: 0.6, cursor: "wait" } : undefined}
                                >
                                    {submitting ? "Inserimento in corso…" : "Inserisci Prenotazione"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default PrenotazioneAddOffcanvas;
